











import { Component, Vue, Prop } from 'vue-property-decorator';
import Loader from '@/shared/components/ui/Loader.vue';
@Component({
    components: {
        Loader,
    },
})
export default class LoadableButton extends Vue {
    @Prop() private loading!: boolean;
    @Prop() private text!: string;
    @Prop() private additionalClasses!: string;
}
